import { ICartDetails } from '../../Cart/ICartDetails.csharp';
import { CheckoutApiRoutes } from '../CheckoutApiRoutes.csharp';
import { CheckoutViewModel } from '../ViewModel/CheckoutViewModel.csharp';
import { CheckoutApiInitializer } from './CheckoutApiInitializer';

export class CheckoutBaseApi {
    protected routes: CheckoutApiRoutes;
    protected getCheckout: () => CheckoutViewModel;
    protected updateCheckout: (checkout: CheckoutViewModel, resetWarnings?: boolean) => void;

    public postalCodeAutocompleteUrl: string;

    constructor(initializer: CheckoutApiInitializer) {
        this.routes = initializer.routes;
        this.getCheckout = initializer.getCheckout;
        this.updateCheckout = initializer.updateCheckout;
        this.postalCodeAutocompleteUrl = this.routes.addressAutocompleteUrl;
    }

    protected get checkout() {
        return this.getCheckout();
    }
}

export function handleCheckoutError<T extends ICartDetails>(error: { status: number }, model: T): T {
    const errorMessage = getStatusErrorMessage(error);
    return setCheckoutError<T>(model, errorMessage);
}

export function setCheckoutError<T extends ICartDetails>(model: T, errorMessage: string): T {
    const cart = { ...model };
    cart.error = { messageKey: errorMessage };

    return cart;
}

export const forbiddenOperationError = 'invalidActionPleaseRefresh';
export const unexpectedOperationError = 'Unexpected';
export const unauthorized = 'expectedActiveSession';

export function getStatusErrorMessage(error: { status: number }) {
    switch (error?.status) {
        case 401:
            return unauthorized;
        case 403:
            return forbiddenOperationError;
        default:
            return unexpectedOperationError;
    }
}
